import React from 'react'
import Palette from './assets/palette'
import { HaikuIconGradioSVG } from './assets/icons'
import NotificationManager from './notification-manager'
import Link from 'gatsby-link'


const STYLES = {
  navWrap: {
    width: '100%',
    zIndex: 3,
    position: 'fixed',
    top: 0,
    left: 0,
    backgroundColor: Palette.FATHER_COAL,
  },
  linksHolster: {
    maxWidth: 1440,
    width: '100%',
    height: '100%',
    margin: '0 auto',
    padding: '13px 45px 1px',
  }
}

const Navbar = ({ location }) => {
  const onHome = location === "home"

  return (
    <div style={STYLES.navWrap}>
      <style>
        {`
        @media screen and (max-width: 737px) {
            display: 'none'
        }
      `}
      </style>

      <div style={STYLES.linksHolster}>
        <Link tabIndex="1"
          className="nav-link"
          to={{ pathname: "/"}}>
            <HaikuIconGradioSVG/>
            <div style={{transform: 'translateY(-9px)', marginLeft: 8, display: 'inline-block'}}>HAIKU</div>
        </Link>

        <a tabIndex="7" className="nav-link right-float nav-link__button"
          style={{
            border: '1px solid ' + Palette.LIGHTEST_PINK,
            borderRadius: 4,
            padding: '4px 10px',
            transform: 'translateY(-5px)'
          }}
          href={`${process.env.ACCOUNT_SITE_URL}/new`}
        >
          GET HAIKU FREE
        </a>

        <Link tabIndex="6" className="nav-link right-float" to={{ pathname: "/pricing"}}>PRICING</Link>

        <Link tabIndex="5" className="nav-link right-float" to={{ pathname: "/blog"}}>BLOG</Link>

        <Link tabIndex="4" className="nav-link right-float" to={{ pathname: "/learn/"}}>LEARN</Link>

        <a tabIndex="3" href="https://share.haiku.ai" className="nav-link right-float">SHOWCASE</a>

        <Link tabIndex="2" className="nav-link right-float" to={{ pathname: "/features/"}}>FEATURES</Link>

        <NotificationManager />
      </div>
    </div>
  )
}

export default Navbar



// WEBPACK FOOTER //
// ./src/components/navbar.js